
import {
  QualificationAction as Action,
  QualificationActionTypes as ActionTypes,
  AffilicationTypeDefinition,
  Qualification,
  QualificationDefinition,
  SpecialQualification,
  SpecialQualificationReference,
  WorkTypeDefinition
} from './types'

export const init = (): Action => ({ type: ActionTypes.INIT});

export const refresh = (): Action => ({ type: ActionTypes.REFRESH});

export const setIsLoading = (isLoading: boolean): Action => ({
  type: ActionTypes.LOADING,
  payload: isLoading,
})
export const setIsHistoryLoading = (isLoading: boolean): Action => ({
  type: ActionTypes.HISTORYLOADING,
  payload: isLoading,
})
export const setIsDetailLoading = (isLoading: boolean): Action => ({
  type: ActionTypes.DETAILLOADING,
  payload: isLoading,
})
export const setIsNavigating = (isNavigating: boolean): Action => ({
  type: ActionTypes.NAVIGATING,
  payload: isNavigating
})

export const setIsNavigatingTo = (isNavigatingTo: number): Action => ({
  type:ActionTypes.NAVIGATINGTO,
  payload: isNavigatingTo
})

export const setIsSubmitting = (isSubmitting: boolean): Action => ({
  type: ActionTypes.SUBMITTING,
  payload: isSubmitting
})

export const setSpecQualifications = (info : SpecialQualification[]): Action => ({
  type: ActionTypes.SET_SELECT_SPECIAL_DEFINITIONS_LIST,
  payload: info
})

export const setQualificationHistory = (info: Qualification[]): Action => ({
  type: ActionTypes.SET_SELECT_QUALIFICATION_HISTORY,
  payload: info
})

export const setSpecQualificationReferences = (info : SpecialQualificationReference[]) : Action => ({
  type: ActionTypes.SET_SELECT_SPECIAL_QUALIFICATION_USED_INPROPERTY,
  payload: info
})

export const setQualifications = (info: Qualification[]) : Action => ({
  type: ActionTypes.SET_SELECT_QUALIFICATIONS,
  payload: info
})

export const setQualificationDefinitions = (info: QualificationDefinition[]) : Action => ({
  type: ActionTypes.SET_SELECT_MST_NATIONAL_QUALIFICATIONS,
  payload: info
})

export const setQualificationDetail = (info: Qualification) : Action => ({
  type: ActionTypes.SET_SELECT_QUALIFICATION_DETAIL,
  payload: info
})
export const setMstWorkTypes = (info: WorkTypeDefinition[]) : Action => ({
  type: ActionTypes.SET_SELECT_MST_WORK_TYPES,
  payload: info
});
export const setAffiliationTypes = (info: AffilicationTypeDefinition[]): Action => ({
  type: ActionTypes.SET_SELECT_MST_AFFILIATION_TYPES,
  payload: info
})

